<template>
  <div class="currency-selector" :class="compact ? 'is-compact' : ''">
    <label v-if="label" class="cs-label">{{ label }}</label>
    <select
      class="cs-select"
      :value="value"
      @change="onChange($event.target.value)"
      :aria-label="label || 'Display currency'"
    >
      <option v-for="row in options" :key="row.currency_code" :value="row.currency_code">
        {{ row.currency_code }}{{ row.symbol ? ' (' + row.symbol + ')' : '' }}
        <template v-if="!compact"> &mdash; {{ row.currency_name }}</template>
      </option>
    </select>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { supportedCurrencies, BASE_CURRENCY } from "@/utils/currency";

/**
 * Display-currency picker.
 *
 * Only lists currencies we hold a RATE for. The countries endpoint knows about ~180
 * countries but the rates table covers 22 - offering a currency with no rate would
 * produce a blank or an invented number.
 */
export default {
  name: "CurrencySelector",
  props: {
    value: { type: String, default: BASE_CURRENCY },
    label: { type: String, default: "" },
    compact: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(["currencies"]),
    options: function () {
      const list = supportedCurrencies(this.currencies);
      if (list.length) { return list; }
      // Rates not loaded yet - still show the base so the control is never empty.
      return [{ currency_code: BASE_CURRENCY, currency_name: "US Dollar", symbol: "$" }];
    },
  },
  methods: {
    onChange: function (code) {
      this.$emit("input", code);
      this.$emit("change", code);
    },
  },
};
</script>

<style scoped>
.currency-selector { display: inline-flex; align-items: center; }
.cs-label {
  margin: 0 8px 0 0;
  font-size: 12px;
  color: #8a94a6;
  white-space: nowrap;
}
.cs-select {
  height: auto !important;
  width: auto !important;
  min-width: 92px;
  padding: 4px 26px 4px 10px;
  border: 1px solid #e4e9f0;
  border-radius: 6px;
  background: #fff;
  font-size: 13px;
  color: #2c3e50;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%206%22%3E%3Cpath%20fill%3D%22%238a94a6%22%20d%3D%22M0%200l5%206%205-6z%22%2F%3E%3C%2Fsvg%3E");
  background-repeat: no-repeat;
  background-position: right 9px center;
  background-size: 9px;
}
.cs-select:focus { outline: none; border-color: #0066b3; }
.is-compact .cs-select { min-width: 76px; font-size: 12px; padding: 3px 24px 3px 8px; }
</style>
